module.exports = __webpack_public_path__ + "assets/img/fr-7696b116.png";